export default __webpack_public_path__ + "static/media/Animals_02.fe66cc14.png";